import { render, staticRenderFns } from "./QuickLaunchFileListItem.vue?vue&type=template&id=23fb9efa"
import script from "./QuickLaunchFileListItem.vue?vue&type=script&lang=js"
export * from "./QuickLaunchFileListItem.vue?vue&type=script&lang=js"
import style0 from "./QuickLaunchFileListItem.vue?vue&type=style&index=0&id=23fb9efa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports